const RemoteApplicationBlockFundsStatusEnum = Object.freeze({
    NONE: 'NONE',
    OUTSTANDING: 'OUTSTANDING',
    CLEARED: 'CLEARED',
    FULLY_CLEARED: 'FULLY_CLEARED'
});

export default RemoteApplicationBlockFundsStatusEnum;
